import React, { useCallback } from 'react';

import { TextButton } from '@fragment/ui/src/components/Button/TextButton/TextButton';
import { Modal } from '@fragment/ui/src/components/Modal/Modal';

import {
  PaymentAccountVerification,
  type PaymentAccountVerificationSession,
} from './PaymentAccountVerification';

export type { PaymentAccountVerificationSession } from './PaymentAccountVerification';

type Props = {
  session: PaymentAccountVerificationSession;
  ledgerId: string;
  createVerificationToken: (
    ledgerId: string
  ) => Promise<PaymentAccountVerificationSession>;
  onClose: VoidFunction;
  onCompleted: VoidFunction;
};

export const PaymentAccountVerificationModal = ({
  session,
  ledgerId,
  createVerificationToken,
  onClose,
  onCompleted,
}: Props) => {
  const renewVerificationToken = useCallback(
    () => createVerificationToken(ledgerId),
    [createVerificationToken, ledgerId]
  );
  return (
    <Modal
      onClose={onClose}
      header={<h2>Verify payment account</h2>}
      body={
        <PaymentAccountVerification
          session={session}
          createVerificationToken={renewVerificationToken}
          onCompleted={onCompleted}
        />
      }
      footer={<TextButton onClick={onClose}>Close</TextButton>}
    />
  );
};
